import React from 'react';
import classes from "./Testimonialprops.module.css";

const Testimonialprops = (props) => {
    return (
  <div className={classes.container}>
      <div className={classes.card}>
   
        <span className={classes.text}>{props.text}</span>
      </div>
    </div>
      
    )
};

export default Testimonialprops